import { Route, Routes } from "react-router-dom"
import QuitPage from "../../pages/QuitPage"

const QuitFlow = () => (
  <Routes>
    <Route element={<QuitPage />} index />
  </Routes>
)

export default QuitFlow
